import { apiClient } from './api';
import { ApiResponse, JournalEntry, JournalBuildResult, JournalPostResult, DimensionCodes, PostingSnapshot, JournalTotals } from '../types';

export const journalService = {
  /**
   * Build journal entries from opportunities
   */
  async buildJournalEntries(batchName: string) {
    const response = await apiClient.post<ApiResponse<JournalBuildResult>>(
      '/api/journal/build',
      { batchName }
    );
    return response.data;
  },

  /**
   * Post journal entries to Sage Intacct
   */
  async postJournalEntries(
    entries: JournalEntry[],
    journalId: string,
    description: string,
    postDate: string,
    location: string,
    batchName?: string,
    totals?: JournalTotals,
    opportunityCount?: number,
    batchAmount?: number
  ) {
    const response = await apiClient.post<ApiResponse<JournalPostResult>>(
      '/api/journal/post',
      { entries, journalId, description, postDate, location, batchName, totals, opportunityCount, batchAmount }
    );
    return response.data;
  },

  /**
   * Validate journal entries
   */
  async validateJournalEntries(entries: JournalEntry[]) {
    const response = await apiClient.post<ApiResponse<{
      entries: JournalEntry[];
      totals: { totalDebit: number; totalCredit: number; balance: number; isBalanced: boolean; bankTotal: number; revenueTotal: number };
      hasErrors: boolean;
      hasWarnings: boolean;
    }>>(
      '/api/journal/validate',
      { entries }
    );
    return response.data;
  },

  /**
   * Get dimension codes for dropdowns (locations, departments, projects, etc.)
   */
  async getDimensionCodes() {
    const response = await apiClient.get<ApiResponse<DimensionCodes>>(
      '/api/sage/dimension-codes'
    );
    return response.data;
  },

  /**
   * Get the posting snapshot for a batch (recorded at time of posting)
   */
  async getPostingSnapshot(batchName: string) {
    const response = await apiClient.get<ApiResponse<PostingSnapshot>>(
      `/api/journal/snapshot/${encodeURIComponent(batchName)}`
    );
    return response.data;
  },
};
